import { Box, ThemeUICSSObject, BoxProps } from '@apia/theme';
import { getLabel } from '@apia/util';

export interface IRequiredMark extends Partial<BoxProps> {
  isFormReadonly?: boolean;
  isRequired?: boolean;
  isReadonly?: boolean;
  sx?: ThemeUICSSObject;
  style?: Record<string, any>;
}

/**
 * Muestra el * en los campos de requerido.
 */
export const RequiredMark = ({
  isFormReadonly = false,
  isRequired = false,
  isReadonly = false,
  sx,
  style,
  ...rest
}: IRequiredMark) => {
  const mergedSx: ThemeUICSSObject = {
    color: 'palette.error.main',
    fontWeight: 'bold',
    ...(sx ?? (style as unknown as ThemeUICSSObject) ?? {}),
  };

  if (!isRequired || isReadonly || isFormReadonly) return null;

  return (
    <Box
      as="span"
      sx={mergedSx}
      className="requiredMark"
      title={getLabel('msgReqField').text}
      {...rest}
    >
      *
    </Box>
  );
};
